
export default {
  props: {
    propListColumnCount: {
      type: Number,
      default: 4,
    },
    lastTradePrice: {
      type: [String, Number],
      default: null,
    },
    lastTradeDate: {
      type: [String, Number],
      default: null,
    },
    swexMarketPrice: {
      type: [String, Number],
      default: null,
    },
    compoundProfit: {
      type: [String, Number],
      default: null,
    },
    priceDevelopment: {
      type: Array,
      default: () => [],
    },
    bottlesAvailableOnTheSwex: {
      type: [String, Number],
      default: null,
    },
    wbRating: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    lastSwexPrice() {
      return this.priceDevelopment.at(-1)
    },

    lastSwexPriceValue() {
      if (!this.lastSwexPrice) {
        return undefined
      }

      // { x: date string, y: value }
      return this.lastSwexPrice.y
    },

    lastSwexPriceDate() {
      if (!this.lastSwexPrice) {
        return undefined
      }

      // { x: date string, y: value }
      return this.lastSwexPrice.x
    },
  },
}
